import { useHasWildfirePriority } from './useHasWildfirePriority';
import { useHasFuelsData } from './useWildfireMode';

export const useHasFuelsWithoutWildfirePriority = (): boolean => {
  const hasFuelsData = useHasFuelsData();
  const hasWildfirePriority = useHasWildfirePriority();
  return hasFuelsData && !hasWildfirePriority;
};
